import { ARTICLE_NUMBER } from '../constants';

export const articleNumber = (articleNumber) => ({
    type: ARTICLE_NUMBER,
    payload: { currentArticleNumber: articleNumber },
});
